import styles from "./tryAgain.module.scss";
import { useEffect, useContext, useRef } from "react";
import { AppAction, AppContext, setLeftPanel } from "helpers/context";
import { useTranslation } from "react-i18next";

interface Props {
    handleRetry: (evt: any) => void;
}

function TryAgain(props: Props) {
    const [t] = useTranslation();
    const contentRef = useRef<HTMLDivElement>(null);
    const [context, dispatch] = useContext(AppContext);

    useEffect(() => {
        const currentRef = contentRef.current;
        if (!currentRef) return;

        // 查找包含"重试"文本的span元素
        const retrySpan = currentRef.querySelector('span');
        retrySpan?.addEventListener('click', props.handleRetry);

        return () => {
            // 清理事件监听器
            if (retrySpan) {
                retrySpan.removeEventListener('click', props.handleRetry);
                dispatch({ type: AppAction.setTryAgainType, payload: "" });
            }
        };
    }, [t]);

    return (<div className={styles.loading}>
        <div className="text-center" style={{ color: "gray" }}><span className="material-icons">error_outline</span></div>
        <div className="text-[14px]">{t("single.graunchTitle")}</div>
        <div ref={contentRef} dangerouslySetInnerHTML={{ __html: t("single.graunchContent") }}></div>
    </div>);
}

export default TryAgain;
